import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const HeatmapStatsChart = ({ stats, factor, unit }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!stats) return;

    const chart = echarts.init(chartRef.current);

    const hours = Object.keys(stats).sort();

    const formatHour = (h) => h.slice(0, 5);

    const max = hours.map(h => stats[h]?.max ?? null);
    const min = hours.map(h => stats[h]?.min ?? null);
    const avg = hours.map(h => stats[h]?.avg ?? null);
    const median = hours.map(h => stats[h]?.median ?? null);
    const stddev = hours.map(h => stats[h]?.stddev ?? null);


    const maxScaled = max.map(v => v != null ? v / factor : null);
    const minScaled = min.map(v => v != null ? v / factor : null);
    const avgScaled = avg.map(v => v != null ? v / factor : null);
    const medianScaled = median.map(v => v != null ? v / factor : null);
    const stddevScaled = stddev.map(v => v != null ? v / factor : null);



    const option = {
      tooltip: {
        trigger: "axis",
        valueFormatter: (value) => {
          return `${value?.toFixed(2)} ${unit}`;
        }
      },

      legend: {
        bottom: 0,
        textStyle: { color: "#374151" }
      },

      grid: {
        left: 60,
        right: 20,
        top: 20,
        bottom: 60
      },

      xAxis: {
        type: "category",
        data: hours.map(formatHour),
        axisLabel: {
          color: "#6b7280"
        },
        axisLine: {
          lineStyle: { color: "#e5e7eb" }
        }
      },

      yAxis: {
        type: "value",
        name: unit,
        nameLocation: "middle",
        nameGap: 50,
        splitLine: {
          lineStyle: {
            type: "dashed",
            color: "#e5e7eb"
          }
        },
        axisLabel: {
          color: "#6b7280"
        }
      },


      series: [
        createSeries("Máx", maxScaled, "#b91c1c"),
        createSeries("Mín", minScaled, "#4f46e5"),
        createSeries("Media", avgScaled, "#f59e0b"),
        createSeries("Mediana", medianScaled, "#10b981"),
        createSeries("Desv. Est.", stddevScaled, "#9ca3af"),
      ]

    };

    chart.setOption(option);

    return () => chart.dispose();
  }, [stats]);

  const createSeries = (name, data, color) => ({
    name,
    type: "line",
    data,
    smooth: true,
    symbol: "circle",
    symbolSize: 6,
    lineStyle: { width: 2, color },
    itemStyle: { color },
  });

  return <div ref={chartRef} style={{ height: 350, width: "100%", marginBottom: "5%" }} />;
};

export default HeatmapStatsChart;
